import styles from './Navigation.module.css'
import cx from 'classnames'
import React, { useState } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'
import { usePluginContext } from '../../contexts/PluginContext'

type NavigationProps = {
    elements: { label: string; path: string }[]
    sidebar?: boolean
}

const Navigation: React.FC<NavigationProps> = ({
    elements,
    sidebar = false,
}) => {
    const { logout } = useAuth()
    const { plugin_id } = usePluginContext()
    const [burgerToggle, setBurgerToggle] = useState<boolean>(false)
    const navigate = useNavigate()
    const location = useLocation()

    return (
        <nav
            className={cx(
                styles['zr-nav'],
                sidebar && styles['zr-nav-sidebar']
            )}
        >
            <div
                className={cx(
                    styles['zr-logo'],
                    sidebar && styles['zr-logo-sidebar']
                )}
            >
                <span>{plugin_id}</span>
            </div>
            <div
                className={cx(
                    styles['zr-desktop-nav'],
                    sidebar && styles['zr-desktop-nav-sidebar']
                )}
            >
                <ul>
                    {elements.map((element, index) => {
                        const isActive = location.pathname === element.path
                        return (
                            <li
                                key={index}
                                onClick={() => navigate(element.path)}
                                className={cx(
                                    isActive && sidebar && styles['zr-active']
                                )}
                            >
                                {element.label}
                            </li>
                        )
                    })}
                </ul>
            </div>
            {!sidebar && (
                <>
                    <label
                        className={cx(styles['zr-burger-menu'])}
                        htmlFor="zr-burger"
                    >
                        <input
                            className={cx(styles['zr-hidden'])}
                            id="zr-burger"
                            type="checkbox"
                            onChange={() => setBurgerToggle((prev) => !prev)}
                        />
                        <span />
                    </label>
                    <div
                        className={cx(
                            styles['zr-mobile-nav'],
                            burgerToggle && styles['zr-checked']
                        )}
                    >
                        <ul>
                            {elements.map((element, index) => {
                                const isActive =
                                    location.pathname === element.path
                                return (
                                    <li
                                        key={index}
                                        onClick={() => navigate(element.path)}
                                        className={cx(
                                            isActive && styles['zr-active']
                                        )}
                                    >
                                        {element.label}
                                    </li>
                                )
                            })}
                            <li
                                onClick={() => logout()}
                                className={cx(
                                    styles['zr-fullscreen-icon-mobile']
                                )}
                            >
                                &#x26BF; Logout
                            </li>
                            <li
                                className={cx(
                                    styles['zr-fullscreen-icon-mobile']
                                )}
                                onClick={() => {
                                    setBurgerToggle(false)
                                }}
                            >
                                &#x26F6; Fullscreen
                            </li>
                        </ul>
                    </div>
                </>
            )}
        </nav>
    )
}

export default Navigation
